import React from 'react';
import {useLocation} from 'react-router-dom';

import {
    ObjectUtils
} from "../../Utils";
import {useChangePage} from "../../Hooks/NavigationHooks";

import {
    useBuildQueryString,
    useGetUrlContextSegment,
    useGetUrlToolSegment
} from "../../Hooks/RouteHooks";


export function StreamBankLink(props) {
    const {
        AllowNew = false,
        style,
        Disabled,
        className = "link-primary",
        role,
        target,
        children,
        Href,
        Tool = null,
        Context = null,
        ToolParam = null
    } = props;

    const getUrlContextSegment = useGetUrlContextSegment();
    const getUrlToolSegment = useGetUrlToolSegment();
    const buildQueryString = useBuildQueryString();
    const changePage = useChangePage();
    const location = useLocation();

    const getHref = () => {
        
        if (Href) {
            //we have a raw url. Let's use that.
            return Href;
        }
        
        const contextSegment = getUrlContextSegment(Context ?? null, AllowNew);
        const toolSegment = Tool ?? getUrlToolSegment();
        const querySegment = buildQueryString(ToolParam);

        return contextSegment + "/" + toolSegment + querySegment;
    }

    const getStyle = () => {
        
        let ret = style ? ObjectUtils.Clone(style) : {};
        if (Disabled) {
            ret.cursor = "default";
        }

        return ret;
    }

    const onClick = (e) => {
        const {
            Disabled
        } = props;

        if (!Disabled) {
            const href = getHref();
            const lastHref = location?.pathname;

            // Check "open in new window/tab" key modifiers are pressed.
            if (e.ctrlKey || e.metaKey || e.target.href === lastHref || e.target.target === '_blank') {
                //run event using the browser's default handling instead of our spa stuff.
                return;
            } else {
                changePage(href);
            }
        }

        e.preventDefault();
    }

    return <a
        className={className}
        role={role}
        style={getStyle()}
        onClick={onClick}
        href={getHref()}
        target={target ?? "_self"}
    >
        {children}
    </a>
}
